const STUDENT_BULK_UPLOAD_TYPES = {
  UPLOAD_REQUEST: 'STUDENT_BULK_UPLOAD/UPLOAD_REQUEST',
  UPLOAD_SUCCESS: 'STUDENT_BULK_UPLOAD/UPLOAD_SUCCESS',
  UPLOAD_FAILURE: 'STUDENT_BULK_UPLOAD/UPLOAD_FAILURE',

  FETCH_JOB_STATUS_REQUEST: 'STUDENT_BULK_UPLOAD/FETCH_JOB_STATUS_REQUEST',
  FETCH_JOB_STATUS_SUCCESS: 'STUDENT_BULK_UPLOAD/FETCH_JOB_STATUS_SUCCESS',
  FETCH_JOB_STATUS_FAILURE: 'STUDENT_BULK_UPLOAD/FETCH_JOB_STATUS_FAILURE',

  CLEAR_CURRENT_JOB: 'STUDENT_BULK_UPLOAD/CLEAR_CURRENT_JOB',
};

export default STUDENT_BULK_UPLOAD_TYPES;
